import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Briefcase } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { tooltipStyle } from "./oversiktConstants";
import { num, dec } from "@/lib/formatters";

const FIELDS = [
  ["sysselsatte", "I arbeid", "#103766"],
  ["arbeidsledige", "Registrerte arbeidslause", "#D35E4E"],
  ["aap_ufore", "AAP / uføretrygd", "#8B5CF6"],
  ["utdanning", "Under utdanning", "#3F8A86"],
  ["andre", "Andre utanfor arbeidsstyrken", "#8AA4BF"],
];

const ArbeidCompareChart = ({ arbeidData }) => {
  const rows = Object.values(arbeidData || {}).filter((k) => k.status_pct);
  if (rows.length === 0) return null;
  const data = rows.map((k) => ({ name: k.name, ...Object.fromEntries(FIELDS.map(([key, label]) => [label, k.status_pct[key] ?? 0])) }));
  return (
    <Card className="bg-white border border-[#E6E9F0] rounded-lg lg:col-span-2" data-testid="compare-arbeid-chart">
      <CardHeader className="border-b border-[#E6E9F0] pb-4">
        <CardTitle className="text-lg font-medium text-[#1F2A36] flex items-center gap-2">
          <Briefcase className="w-5 h-5 text-[#103766]" />
          Arbeid, arbeidsløyse og ytingar {rows[0].year} (andel av busette 20–66 år, %)
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-6">
        <div className="h-[340px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} barCategoryGap="25%">
              <CartesianGrid strokeDasharray="3 3" stroke="#E6E9F0" />
              <XAxis dataKey="name" stroke="#8AA4BF" fontSize={12} />
              <YAxis stroke="#8AA4BF" fontSize={12} tickFormatter={(v) => `${num(v)} %`} />
              <Tooltip formatter={(v) => `${num(v)} %`} contentStyle={tooltipStyle} />
              <Legend itemSorter={null} />
              {FIELDS.map(([key, label, color]) => <Bar key={key} dataKey={label} fill={color} radius={[4, 4, 0, 0]} />)}
            </BarChart>
          </ResponsiveContainer>
        </div>
        <p className="text-xs text-[#8AA4BF] mt-4 text-center">Kjelde: SSB 13563 – prioritert arbeidsstyrkestatus. Heiltidsandel blant sysselsette: {rows.map((k) => `${k.name} ${k.arbeidstid_pct?.p100 != null ? dec(k.arbeidstid_pct.p100, 1) : "—"} %`).join(" · ")}</p>
      </CardContent>
    </Card>
  );
};

export default ArbeidCompareChart;
